import { render, staticRenderFns } from "./DataTablePagination.vue?vue&type=template&id=2e45ce11&scoped=true&"
import script from "./DataTablePagination.vue?vue&type=script&lang=js&"
export * from "./DataTablePagination.vue?vue&type=script&lang=js&"
import style0 from "./DataTablePagination.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DataTablePagination.vue?vue&type=style&index=1&id=2e45ce11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e45ce11",
  null
  
)

export default component.exports